import React, { RefObject } from "react";
import { Flex } from "@chakra-ui/react";
import useScrolledToBottom from "@/shared/hooks/useScrolledToBottom";
import PathPickScrollToTopCircleButton from "@/features/pathpick/components/ui/PathPickScrollToTopCircleButton";

interface Props {
  containerRef: RefObject<HTMLDivElement>;
}

// 목록 마지막 행 다음 줄 가운데에 놓이는 "맨 위로" 버튼.
function PathPickScrollToTopButton({ containerRef }: Props) {
  const isAtBottom = useScrolledToBottom(containerRef);

  // 바닥에 닿았을 때만 보이지만 자리는 항상 차지한다. 조건부로 DOM을 넣고 빼면
  // "버튼 등장 → 내용이 길어져 더는 바닥이 아님 → 버튼 사라짐"이 반복되며 깜빡인다.
  return (
    <Flex height={"48px"} justifyContent={"center"} alignItems={"center"}>
      <PathPickScrollToTopCircleButton
        containerRef={containerRef}
        isVisible={isAtBottom}
      />
    </Flex>
  );
}

export default PathPickScrollToTopButton;
